import React from 'react';
import { Wallet2, ArrowRight, Sparkle } from "lucide-react";
import './HeroSection.css';

const HeroSection = () => {
  const stakingStats = [
    {
      title: "Total Holding",
      value: "Connect Wallet",
      subtitle: "$bSIM"
    },
    {
      title: "Total Staked",
      value: "Connect Wallet",
      subtitle: "$bSIM"
    },
    {
      title: "Earnings",
      value: "Connect Wallet",
      subtitle: "Redacted"
    }
  ];

  // Helper function to generate octagon path
  const getOctagonPath = (size) => {
    const side = size * 0.3; // Shorter sides for more octagonal shape
    return `M ${side} 0 
            L ${size - side} 0 
            L ${size} ${side} 
            L ${size} ${size - side} 
            L ${size - side} ${size} 
            L ${side} ${size} 
            L 0 ${size - side} 
            L 0 ${side} Z`;
  };

  const renderGridCells = () => {
    const rows = 24;
    const cols = 16;
    const cellSize = 50;
    const cells = [];
    
    for (let i = 0; i < rows; i++) {
      for (let j = 0; j < cols; j++) {
        const xOffset = i % 2 === 0 ? 0 : cellSize / 2;
        const x = j * (cellSize * 1.1) + xOffset; // Add 10% gap between cells
        const y = i * (cellSize * 0.75); // Adjust vertical spacing
        
        // Create a pattern based on position
        const isSpecial = (i + j) % 3 === 0; // Every third cell in a diagonal pattern
        
        cells.push(
          <g
            key={`${i}-${j}`}
            transform={`translate(${x}, ${y})`}
            className={`grid-cell ${isSpecial ? 'special' : (i + j) % 2 === 0 ? 'even' : 'odd'}`}
            style={{
              animationDelay: `${Math.random() * 2}s`,
              transitionDelay: `${Math.random() * 0.5}s`
            }}
          >
            <path
              d={getOctagonPath(cellSize)}
              className="octagon-path"
            />
          </g>
        );
      }
    }
    return cells;
  };

  const handleLearnMoreClick = () => {
    const footer = document.querySelector('footer');
    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback if footer is not found
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="hero-section">
      <div className="grid-container">
        <div className="grid-overlay">
          <svg
            viewBox="-200 -200 1400 2000"
            className="octagonal-grid-svg"
            preserveAspectRatio="xMidYMid slice"
          >
            {renderGridCells()}
          </svg>
        </div>
        
        <div className="gradient-blob blob-1" />
        <div className="gradient-blob blob-2" />
      </div>

      <div className="hero-content">
        <div className="sparkle-container">
          <Sparkle className="sparkle-icon" />
        </div>
        <div className="vector-container">
          <img src="/brain-icon.png" alt="Vector" className="vector-logo" />
          <span className="sim-number">314</span>
        </div>
        <h1 className="hero-title">
          BasedStation
        </h1>
        <p className="hero-description">
          Stake $bSIM To Enter The Backrooms
        </p>
        <div className="button-container">
          <button className="stake-button" disabled>
            Coming Soon <Wallet2 className="button-icon" />
          </button>
          <button className="learn-button" onClick={handleLearnMoreClick}>
            Learn More <ArrowRight className="button-icon" />
          </button>
        </div>

        <div className="staking-cards-container">
          {stakingStats.map((stat, index) => (
            <div key={index} className="staking-card">
              <span className="staking-card-title">{stat.title}</span>
              <span className="staking-card-value">{stat.value}</span>
              <span className="staking-card-subtitle">{stat.subtitle}</span>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default HeroSection;